import React, { Component } from 'react';

import { View, TextInput, StyleSheet, Platform, I18nManager } from 'react-native';

const isWeb = Platform.OS === 'web';
const isNative = !isWeb;
const clone = arr => [...arr];
const indexOf = (arr, item) => arr.indexOf(item);
const merge = (ob1, ob2) => ({ ...ob1, ...ob2 });

export class ConfirmationCodeInput extends Component {
  static defaultProps = {
    codeLength: 5,
    inputPosition: 'center',
    autoFocus: true,
    size: 40,
    className: 'border-box',
    cellBorderWidth: 1,
    activeColor: 'rgba(255, 255, 255, 1)',
    inactiveColor: 'rgba(255, 255, 255, 0.2)',
    space: 8,
    compareWithCode: '',
    ignoreCase: false
  };

  constructor(props) {
    super(props);

    this.state = {
      codeArr: new Array(this.props.codeLength).fill(''),
      currentIndex: 0
    };
  }
  _setFocus = (id, mounting) => {
    if (isNative) {
      for (let i = 0; i < this.props.codeLength; i++) {
        id !== i && this[`dig${i}`] && this[`dig${i}`].blur();
      }
      this[`dig${id}`] && this[`dig${id}`].focus();
    }
  };

  componentDidMount() {
    const { compareWithCode, codeLength, inputPosition } = this.props;
    if (compareWithCode && compareWithCode.length !== codeLength) {
      console.error('Invalid props: compareWith length is not equal to codeLength');
    }

    if (indexOf(['center', 'left', 'right', 'full-width'], inputPosition) === -1) {
      console.error('Invalid input position. Must be in: center, left, right, full');
    }
    this.props.autoFocus && this._setFocus(this.state.currentIndex);
  }
  componentDidUpdate(_, prev) {
    prev.currentIndex !== this.state.currentIndex && this.enablePress === 0 && this._setFocus(this.state.currentIndex);
  }

  _onFocus(index) {
    let newCodeArr = clone(this.state.codeArr);

    for (const i in newCodeArr) {
      if (i >= index) {
        newCodeArr[i] = '';
      }
    }
    const { onChangeText } = this.props;
    const code = newCodeArr.join('');
    onChangeText && onChangeText(code);
    this.enablePress++;

    this.setState({
      codeArr: newCodeArr,
      currentIndex: index
    });
  }

  _getContainerStyle(size, position) {
    switch (position) {
      case 'left':
        return {
          justifyContent: 'flex-start',
          height: size
        };
      case 'center':
        return {
          justifyContent: 'center',
          height: size
        };
      case 'right':
        return {
          justifyContent: 'flex-end',
          height: size
        };
      default:
        return {
          // justifyContent: 'space-between',
          height: size
        };
    }
  }

  _getInputSpaceStyle(space) {
    const { inputPosition } = this.props;
    switch (inputPosition) {
      case 'left':
        return {
          marginRight: space
        };
      case 'center':
        return {
          marginRight: space / 2,
          marginLeft: space / 2
        };
      case 'right':
        return {
          marginLeft: space
        };
      default:
        return {
          marginRight: 0,
          marginLeft: 0
        };
    }
  }

  _getClassStyle(className, active) {
    const { cellBorderWidth, activeColor, inactiveColor, space } = this.props;
    let classStyle = {
      ...this._getInputSpaceStyle(space),
      color: activeColor
    };

    switch (className) {
      case 'clear':
        return merge(classStyle, { borderWidth: 0 });
      case 'border-box':
        return merge(classStyle, {
          borderWidth: cellBorderWidth,
          borderColor: active ? activeColor : inactiveColor
        });
      case 'border-circle':
        return merge(classStyle, {
          borderWidth: cellBorderWidth,
          borderRadius: 50,
          borderColor: active ? activeColor : inactiveColor
        });
      case 'border-b':
        return merge(classStyle, {
          borderBottomWidth: cellBorderWidth,
          borderColor: active ? activeColor : inactiveColor
        });
      case 'border-b-t':
        return merge(classStyle, {
          borderTopWidth: cellBorderWidth,
          borderBottomWidth: cellBorderWidth,
          borderColor: active ? activeColor : inactiveColor
        });
      case 'border-l-r':
        return merge(classStyle, {
          borderLeftWidth: cellBorderWidth,
          borderRightWidth: cellBorderWidth,
          borderColor: active ? activeColor : inactiveColor
        });
      default:
        return className;
    }
  }

  _onKeyPress(e, id) {
    const { currentIndex, codeArr } = this.state;
    if (e.nativeEvent.key === 'Backspace' && this.enablePress === 1 && currentIndex === id) {
      const { onChangeText } = this.props;
      const nextIndex = currentIndex > 0 ? currentIndex - 1 : 0;
      const code = codeArr.join('');
      onChangeText && onChangeText(code);
      this.setState({ currentIndex: nextIndex });
    }
    this.enablePress = 0;
    //;
  }

  /** synthesizes the input characters based on the keyboard type removing invalid characters */
  _synthesizeInput = characters => {
    const { keyboardType } = this.props;
    if (keyboardType === 'numeric') {
      return characters.replace(/\D/g, '');
    }
    return characters.toUpperCase().replace(/[^0-9|A-Z]/g, '0');
  };

  _onInputCode(baseCharacters, baseIndex) {
    const { codeLength, onFulfill, onChangeText } = this.props;
    this.enablePress = 0;
    const characters = this._synthesizeInput(baseCharacters).substring(0, 1);

    let newCodeArr = clone(this.state.codeArr);

    newCodeArr[baseIndex] = characters;
    /** constructed plain code */
    const code = newCodeArr.join('');
    if (baseIndex === codeLength - 1 && code.length === codeLength) {
      onFulfill(code);
      this[`dig${baseIndex}`] && this[`dig${baseIndex}`].blur();
    }

    onChangeText && onChangeText(code);
    this.setState({
      codeArr: newCodeArr,
      currentIndex: baseIndex < codeLength - 1 && characters !== '' ? baseIndex + 1 : baseIndex
    });
  }

  render() {
    const {
      codeLength,
      codeInputStyle,
      containerStyle,
      inputPosition,
      autoFocus,
      className,
      size,
      activeColor,
      compareWithCode,
      space,
      cellBorderWidth,
      inactiveColor,
      ignoreCase,
      onFulfill,
      onChangeText,
      keyboardType,
      ...props
    } = this.props;

    const { currentIndex } = this.state;
    const initialCodeInputStyle = {
      width: size,
      height: size
    };

    let codeInputs = [];
    for (let i = 0; i < codeLength; i++) {
      const id = i;
      codeInputs.push(
        <TextInput
          key={`${id}${isWeb && id === currentIndex}`}
          ref={ref => (this[`dig${id}`] = ref)}
          style={[styles.codeInput, initialCodeInputStyle, this._getClassStyle(className, currentIndex === id), isWeb && { outline: 'none' }, codeInputStyle]}
          underlineColorAndroid="transparent"
          selectionColor={activeColor}
          keyboardType={keyboardType}
          returnKeyType={'done'}
          autoCorrect={false}
          autoFocus={autoFocus && isWeb && id === currentIndex}
          onFocus={() => this._onFocus(id)}
          value={this.state.codeArr[id] ? this.state.codeArr[id] : ''}
          onChangeText={text => this._onInputCode(text, id)}
          onKeyPress={e => this._onKeyPress(e, id)}
        />
      );
    }

    return <View style={[styles.container, containerStyle, { flexDirection: I18nManager.isRTL ? 'row-reverse' : 'row' }]}>{codeInputs}</View>;
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',

    minHeight: 42
  },
  codeInput: {
    backgroundColor: 'transparent',
    textAlign: 'center',
    padding: 0
  }
});



// WEBPACK FOOTER //
// ./src/components/core/confirmation_code_input.js